module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader()),
      expression: "showLoader()"
    }],
    staticClass: "loader"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw"
  }), _vm._v(" "), _c('div', [_vm._v("Loading")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFinished()),
      expression: "showFinished()"
    }],
    staticClass: "finished"
  }, [_c('h3', [_vm._v("My Canadian Coat of Arms")]), _vm._v(" "), _c('canvas', {
    ref: "canvas",
    attrs: {
      "id": "canvas",
      "width": _vm.imageWidth,
      "height": _vm.imageHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-button-group', [_c('b-button', {
    staticClass: "download",
    on: {
      "click": _vm.downloadImg
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Download Image")])]), _vm._v(" "), _c('b-button', {
    staticClass: "facebook",
    class: {
      loading: _vm.fbLoading
    },
    on: {
      "click": function($event) {
        _vm.shareImage('Facebook')
      }
    }
  }, [_c('i', {
    staticClass: "share-loader fa fa-circle-o-notch fa-spin fa-fw"
  }), _vm._v(" "), _c('i', {
    staticClass: "media-icon fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Share on Facebook")])]), _vm._v(" "), _c('b-button', {
    staticClass: "twitter",
    class: {
      loading: _vm.twLoading
    },
    on: {
      "click": function($event) {
        _vm.shareImage('Twitter')
      }
    }
  }, [_c('i', {
    staticClass: "share-loader fa fa-circle-o-notch fa-spin fa-fw"
  }), _vm._v(" "), _c('i', {
    staticClass: "media-icon fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Share on Twitter")])])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "start-over",
    on: {
      "click": _vm.restart
    }
  }, [_vm._v("Like it? Share it! Don't like it? "), _c('a', [_vm._v("Try Again")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "shareModal",
      "title": 'Your image is ready to share on ' + _vm.sharePlatform,
      "visible": _vm.shareModalState,
      "hide-footer": true
    },
    on: {
      "hidden": function($event) {
        _vm.clearModal('share')
      },
      "cancel": function($event) {
        _vm.clearModal('share')
      }
    }
  }, [_c('a', {
    staticClass: "btn btn-lg btn-primary btn-block",
    class: {
      facebook: _vm.fbLoading, twitter: _vm.twLoading
    },
    attrs: {
      "href": _vm.shareLink,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.hideModal('share')
      }
    }
  }, [_vm._v("Share It!")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "errorModal",
      "title": "Sorry! There was an error sharing your image",
      "visible": _vm.errorModalState,
      "hide-footer": true
    },
    on: {
      "hidden": function($event) {
        _vm.clearModal('error')
      },
      "cancel": function($event) {
        _vm.clearModal('error')
      }
    }
  }, [_c('b-button', {
    staticClass: "twitter",
    on: {
      "click": function($event) {
        _vm.hideModal('error')
      }
    }
  }, [_vm._v("OK")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb73633c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Result.vue
// module id = 84
// module chunks = 1